import gql from 'graphql-tag';
const CREATE_HASHED_EMAIL_LIST = gql`
  mutation createHashedEmailList(
    $name: String!
    $hashedEmailIds: [HashedEmailAddressWhereUniqueInput!]
    $orgID: ID!
    $stepProgress: Int
    $status: EnumFirstPartyDataStatus
    $typeOfFirstPartyData: String
  ) {
    createHashedEmailList(
      data: {
        name: $name
        hashedEmails: { connect: $hashedEmailIds }
        typeOfFirstPartyData: $typeOfFirstPartyData
        orgs: { connect: [{ id: $orgID }] }
        stepProgress: $stepProgress
        status: $status
      }
    ) {
      id
      name
      stepProgress
      status
    }
  }
`;

export default CREATE_HASHED_EMAIL_LIST;
